import { useMemo, useState } from 'react'
import Button from '@/components/common/Button/Button'
import { useLocation, useCreateUserLocation } from '@/hooks/useLocation'
import { useDistricts } from '@/hooks/useServices'
import useModalStore from '@/stores/ModalStore'
import './LocationSetup.css'

const LocationSetup = ({ handleClose }: { handleClose?: () => void }) => {
    const { location, setManualLocation } = useLocation()
    const { data: districts = [] } = useDistricts()

    const [selectedDistrictId, setSelectedDistrictId] = useState<number | ''>(location?.districtId ?? '')
    const [customReference, setCustomReference] = useState(location?.address ?? '')

    const { closeModal } = useModalStore()
    const { mutate: createLocation, isPending: isSaving } = useCreateUserLocation()

    const selectedDistrict = useMemo(() => {
        if (!selectedDistrictId) return null
        return districts.find((district: any) => district.id === Number(selectedDistrictId)) || null
    }, [selectedDistrictId, districts])

    const handleSave = () => {
        if (!selectedDistrict) {
            alert('Selecciona un distrito para continuar')
            return
        }

        const payload = {
            districtId: selectedDistrict.id,
            districtName: selectedDistrict.name,
            address: customReference.trim(),
            city: 'Lima',
            label: 'Mi distrito',
            is_default: true,
        }

        // Persist for compatibilidad con API actual (dirección opcional)
        createLocation(payload, {
            onSettled: () => {
                setManualLocation(payload)
                closeModal()
                handleClose?.()
            },
        })
    }

    return (
        <div className="locsetup_container">
            <h3 className="locsetup_title">Selecciona tu distrito</h3>
            <p className="locsetup_subtitle">
                Solo te mostraremos proveedores que atienden en tu distrito
            </p>
            
            <div className="locsetup_field">
                <label>Distrito</label>
                <select
                    className="locsetup_input"
                    value={selectedDistrictId}
                    onChange={(e) => setSelectedDistrictId(e.target.value ? Number(e.target.value) : '')}
                >
                    <option value="">Selecciona un distrito...</option>
                    {districts.map((district: any) => (
                        <option key={district.id} value={district.id}>
                            {district.name}
                        </option>
                    ))}
                </select>
            </div>

            <div className="locsetup_field">
                <label>Referencia (opcional)</label>
                <input
                    value={customReference}
                    onChange={(e) => setCustomReference(e.target.value)}
                    placeholder="Ej: Cerca al parque principal"
                    className="locsetup_input"
                />
            </div>

            <div className="locsetup_actions">
                <Button
                    variant="primary"
                    size="lg"
                    onClick={handleSave}
                    disabled={!selectedDistrictId || isSaving}
                >
                    {isSaving ? 'Guardando...' : 'Guardar distrito'}
                </Button>
                <Button
                    variant="secondary"
                    size="lg"
                    onClick={() => {
                        closeModal()
                        handleClose?.()
                    }}
                >
                    Cancelar
                </Button>
            </div>
        </div>
    )
}

export default LocationSetup


